<template>
  <div class="search">
    <Row>
      <Col>
        <Card>
          <Row @keydown.enter.native="handleSearch">
            <Form ref="searchForm" :model="searchForm" inline :label-width="70" class="search-form">
              <Form-item label="自增ID" prop="orderCommonId">
                <Input type="text" v-model="searchForm.orderCommonId" placeholder="请输入自增ID" clearable style="width: 200px"/>
              </Form-item>
              <Form-item label="作者名字" prop="authorNames">
                <Input type="text" v-model="searchForm.authorNames" placeholder="请输入作者名字" clearable style="width: 200px"/>
              </Form-item>
              <span v-if="drop">
                <Form-item label="权利人名称" prop="obligeeNames">
                  <Input type="text" v-model="searchForm.obligeeNames" placeholder="请输入权利人名称" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="作者署名" prop="authorSign">
                  <Input type="text" v-model="searchForm.authorSign" placeholder="请输入作者署名" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="权利归属方式. 1.个人作品 2. 合作作品 3.法人作品  4 职务作品  5 委托作品" prop="copyrightType">
                  <Input type="text" v-model="searchForm.copyrightType" placeholder="请输入权利归属方式. 1.个人作品 2. 合作作品 3.法人作品  4 职务作品  5 委托作品" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="创作类型  ORIGINAL(1,  原创 ),ADAPTATION(2,  改编 ),TRANSLATION(3,  翻译 ),COMPILATION(4,  汇编 ),ANNOTATE(5,  注释 ),ARRANGE(6,  整理 ),OTHER(7,  其他 );" prop="creativeType">
                  <Input type="text" v-model="searchForm.creativeType" placeholder="请输入创作类型  ORIGINAL(1,  原创 ),ADAPTATION(2,  改编 ),TRANSLATION(3,  翻译 ),COMPILATION(4,  汇编 ),ANNOTATE(5,  注释 ),ARRANGE(6,  整理 ),OTHER(7,  其他 );" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="完成省份" prop="completeProvince">
                  <Input type="text" v-model="searchForm.completeProvince" placeholder="请输入完成省份" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="完成城市" prop="completeCity">
                  <Input type="text" v-model="searchForm.completeCity" placeholder="请输入完成城市" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="完成国家" prop="completeCountry">
                  <Input type="text" v-model="searchForm.completeCountry" placeholder="请输入完成国家" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="完成日期" prop="completeDate">
                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                </Form-item>
                <Form-item label="发布省份" prop="publishProvince">
                  <Input type="text" v-model="searchForm.publishProvince" placeholder="请输入发布省份" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="发布城市" prop="publishCity">
                  <Input type="text" v-model="searchForm.publishCity" placeholder="请输入发布城市" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="发布国家" prop="publishCountry">
                  <Input type="text" v-model="searchForm.publishCountry" placeholder="请输入发布国家" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="发布日期" prop="publishDate">
                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                </Form-item>
                <Form-item label="" prop="publishPlatform">
                  <Input type="text" v-model="searchForm.publishPlatform" placeholder="请输入" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="发布状态. 1已发布  0 未发布" prop="publishStatus">
                  <Input type="text" v-model="searchForm.publishStatus" placeholder="请输入发布状态. 1已发布  0 未发布" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="权利取得方式 1 原始取得  2.承受  3 继承 4 其他" prop="powerBy">
                  <Input type="text" v-model="searchForm.powerBy" placeholder="请输入权利取得方式 1 原始取得  2.承受  3 继承 4 其他" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="权利范围  ：  publish( 发表权 , 1) signature( 署名权 , 2), revision( 修改权 , 3),  completion( 保护作品完整权 , 4),    copy( 复制权 , 5),    launch( 发行权 , 6),  rent( 出租权 , 7),  exhibition( 展览权 , 8),     performance( 表演权 , 9), projection( 放映权 , 10),  broadcast( 广播权 , 11), internet( 信息网络传播权 , 12), produce( 摄制权 , 13), adaptation( 改编权 , 14),   translation( 翻译权 , 15),  compilation( 汇编权 , 16), other( 其他 , 17), all( 全部权利 , 18),   part( 部分权利 , 19);//" prop="powerScope">
                  <Input type="text" v-model="searchForm.powerScope" placeholder="请输入权利范围  ：  publish( 发表权 , 1) signature( 署名权 , 2), revision( 修改权 , 3),  completion( 保护作品完整权 , 4),    copy( 复制权 , 5),    launch( 发行权 , 6),  rent( 出租权 , 7),  exhibition( 展览权 , 8),     performance( 表演权 , 9), projection( 放映权 , 10),  broadcast( 广播权 , 11), internet( 信息网络传播权 , 12), produce( 摄制权 , 13), adaptation( 改编权 , 14),   translation( 翻译权 , 15),  compilation( 汇编权 , 16), other( 其他 , 17), all( 全部权利 , 18),   part( 部分权利 , 19);//" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="作品全称" prop="workFullname">
                  <Input type="text" v-model="searchForm.workFullname" placeholder="请输入作品全称" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="作品小类，见work_type_copyright中的code字段值" prop="workType">
                  <Input type="text" v-model="searchForm.workType" placeholder="请输入作品小类，见work_type_copyright中的code字段值" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="作品大类，见work_type_copyright中的code字段值" prop="workTypeDesc">
                  <Input type="text" v-model="searchForm.workTypeDesc" placeholder="请输入作品大类，见work_type_copyright中的code字段值" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="著作权原创声明书url" prop="workStatement">
                  <Input type="text" v-model="searchForm.workStatement" placeholder="请输入著作权原创声明书url" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="作品创作说明书" prop="workInstruction">
                  <Input type="text" v-model="searchForm.workInstruction" placeholder="请输入作品创作说明书" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="法人证明文件 copyright_type为2 合作作品时，此字段应有值" prop="workCorporate">
                  <Input type="text" v-model="searchForm.workCorporate" placeholder="请输入法人证明文件 copyright_type为2 合作作品时，此字段应有值" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="职务作品url  copyright_type为4时需要提交此证明" prop="workJobProduction">
                  <Input type="text" v-model="searchForm.workJobProduction" placeholder="请输入职务作品url  copyright_type为4时需要提交此证明" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="合作创作证明" prop="workCooperationThat">
                  <Input type="text" v-model="searchForm.workCooperationThat" placeholder="请输入合作创作证明" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label=" 委托声明url   当copyright_type为5 委托作品时 需要提交的材料" prop="workEntrustStatementUrl">
                  <Input type="text" v-model="searchForm.workEntrustStatementUrl" placeholder="请输入 委托声明url   当copyright_type为5 委托作品时 需要提交的材料" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="委托说明" prop="entrustContent">
                  <Input type="text" v-model="searchForm.entrustContent" placeholder="请输入委托说明" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="版权声明" prop="copyrightStatements">
                  <Input type="text" v-model="searchForm.copyrightStatements" placeholder="请输入版权声明" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="证明文件Url" prop="certificationFileUrl">
                  <Input type="text" v-model="searchForm.certificationFileUrl" placeholder="请输入证明文件Url" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="合作创作协议文件" prop="coCreationAgreement">
                  <Input type="text" v-model="searchForm.coCreationAgreement" placeholder="请输入合作创作协议文件" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="区块链公示Hash" prop="publicHash">
                  <Input type="text" v-model="searchForm.publicHash" placeholder="请输入区块链公示Hash" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="创建者" prop="createBy">
                  <Input type="text" v-model="searchForm.createBy" placeholder="请输入创建者" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="创建时间" prop="createDate">
                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                </Form-item>
                <Form-item label="更新者" prop="updateBy">
                  <Input type="text" v-model="searchForm.updateBy" placeholder="请输入更新者" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="更新时间" prop="updateDate">
                  <DatePicker v-model="selectDate" type="daterange" format="yyyy-MM-dd" clearable @on-change="selectDateRange" placeholder="选择起始时间" style="width: 200px"></DatePicker>
                </Form-item>
                <Form-item label="备注信息" prop="remarks">
                  <Input type="text" v-model="searchForm.remarks" placeholder="请输入备注信息" clearable style="width: 200px"/>
                </Form-item>
                <Form-item label="删除标记" prop="delFlag">
                  <Input type="text" v-model="searchForm.delFlag" placeholder="请输入删除标记" clearable style="width: 200px"/>
                </Form-item>
              </span>
              <Form-item style="margin-left:-35px;" class="br">
                <Button @click="handleSearch" type="primary" icon="ios-search">搜索</Button>
                <Button @click="handleReset">重置</Button>
                <a class="drop-down" @click="dropDown">
                  {{dropDownContent}}
                  <Icon :type="dropDownIcon"></Icon>
                </a>
              </Form-item>
            </Form>
          </Row>
          <Row class="operation">
            <Button @click="add" type="primary" icon="md-add">添加</Button>
            <Button @click="delAll" icon="md-trash">批量删除</Button>
            <Button @click="getDataList" icon="md-refresh">刷新</Button>
          </Row>
          <Row>
            <Alert show-icon>
              已选择 <span class="select-count">{{selectCount}}</span> 项
              <a class="select-clear" @click="clearSelectAll">清空</a>
            </Alert>
          </Row>
          <Row>
            <Table :loading="loading" border :columns="columns" :data="data" ref="table" sortable="custom" @on-sort-change="changeSort" @on-selection-change="changeSelect"></Table>
          </Row>
          <Row type="flex" justify="end" class="page">
            <Page :current="searchForm.pageNumber" :total="total" :page-size="searchForm.pageSize" @on-change="changePage" @on-page-size-change="changePageSize" :page-size-opts="[10,20,50]" size="small" show-total show-elevator show-sizer></Page>
          </Row>
        </Card>
      </Col>
    </Row>
    <Modal :title="modalTitle" v-model="modalVisible" :mask-closable='false' :width="500">
      <Form ref="form" :model="form" :label-width="100" :rules="formValidate" >        <FormItem label="自增ID" prop="orderCommonId" >
          <Input v-model="form.orderCommonId" style="width:100%"/>
        </FormItem>
        <FormItem label="作者名字" prop="authorNames" >
          <Input v-model="form.authorNames" style="width:100%"/>
        </FormItem>
        <FormItem label="权利人名称" prop="obligeeNames" >
          <Input v-model="form.obligeeNames" style="width:100%"/>
        </FormItem>
        <FormItem label="作者署名" prop="authorSign" >
          <Input v-model="form.authorSign" style="width:100%"/>
        </FormItem>
        <FormItem label="权利归属方式. 1.个人作品 2. 合作作品 3.法人作品  4 职务作品  5 委托作品" prop="copyrightType" >
          <Input v-model="form.copyrightType" style="width:100%"/>
        </FormItem>
        <FormItem label="创作类型  ORIGINAL(1,  原创 ),ADAPTATION(2,  改编 ),TRANSLATION(3,  翻译 ),COMPILATION(4,  汇编 ),ANNOTATE(5,  注释 ),ARRANGE(6,  整理 ),OTHER(7,  其他 );" prop="creativeType" >
          <Input v-model="form.creativeType" style="width:100%"/>
        </FormItem>
        <FormItem label="完成省份" prop="completeProvince" >
          <Input v-model="form.completeProvince" style="width:100%"/>
        </FormItem>
        <FormItem label="完成城市" prop="completeCity" >
          <Input v-model="form.completeCity" style="width:100%"/>
        </FormItem>
        <FormItem label="完成国家" prop="completeCountry" >
          <Input v-model="form.completeCountry" style="width:100%"/>
        </FormItem>
        <FormItem label="完成日期" prop="completeDate" >
            <DatePicker type="date" v-model="form.completeDate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="发布省份" prop="publishProvince" >
          <Input v-model="form.publishProvince" style="width:100%"/>
        </FormItem>
        <FormItem label="发布城市" prop="publishCity" >
          <Input v-model="form.publishCity" style="width:100%"/>
        </FormItem>
        <FormItem label="发布国家" prop="publishCountry" >
          <Input v-model="form.publishCountry" style="width:100%"/>
        </FormItem>
        <FormItem label="发布日期" prop="publishDate" >
            <DatePicker type="date" v-model="form.publishDate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="" prop="publishPlatform" >
          <Input v-model="form.publishPlatform" style="width:100%"/>
        </FormItem>
        <FormItem label="发布状态. 1已发布  0 未发布" prop="publishStatus" >
          <Input v-model="form.publishStatus" style="width:100%"/>
        </FormItem>
        <FormItem label="权利取得方式 1 原始取得  2.承受  3 继承 4 其他" prop="powerBy" >
          <Input v-model="form.powerBy" style="width:100%"/>
        </FormItem>
        <FormItem label="权利范围  ：  publish( 发表权 , 1) signature( 署名权 , 2), revision( 修改权 , 3),  completion( 保护作品完整权 , 4),    copy( 复制权 , 5),    launch( 发行权 , 6),  rent( 出租权 , 7),  exhibition( 展览权 , 8),     performance( 表演权 , 9), projection( 放映权 , 10),  broadcast( 广播权 , 11), internet( 信息网络传播权 , 12), produce( 摄制权 , 13), adaptation( 改编权 , 14),   translation( 翻译权 , 15),  compilation( 汇编权 , 16), other( 其他 , 17), all( 全部权利 , 18),   part( 部分权利 , 19);//" prop="powerScope" >
          <Input v-model="form.powerScope" style="width:100%"/>
        </FormItem>
        <FormItem label="作品全称" prop="workFullname" >
          <Input v-model="form.workFullname" style="width:100%"/>
        </FormItem>
        <FormItem label="作品小类，见work_type_copyright中的code字段值" prop="workType" >
          <Input v-model="form.workType" style="width:100%"/>
        </FormItem>
        <FormItem label="作品大类，见work_type_copyright中的code字段值" prop="workTypeDesc" >
          <Input v-model="form.workTypeDesc" style="width:100%"/>
        </FormItem>
        <FormItem label="著作权原创声明书url" prop="workStatement" >
          <Input v-model="form.workStatement" style="width:100%"/>
        </FormItem>
        <FormItem label="作品创作说明书" prop="workInstruction" >
          <Input v-model="form.workInstruction" style="width:100%"/>
        </FormItem>
        <FormItem label="法人证明文件 copyright_type为2 合作作品时，此字段应有值" prop="workCorporate" >
          <Input v-model="form.workCorporate" style="width:100%"/>
        </FormItem>
        <FormItem label="职务作品url  copyright_type为4时需要提交此证明" prop="workJobProduction" >
          <Input v-model="form.workJobProduction" style="width:100%"/>
        </FormItem>
        <FormItem label="合作创作证明" prop="workCooperationThat" >
          <Input v-model="form.workCooperationThat" style="width:100%"/>
        </FormItem>
        <FormItem label=" 委托声明url   当copyright_type为5 委托作品时 需要提交的材料" prop="workEntrustStatementUrl" >
          <Input v-model="form.workEntrustStatementUrl" style="width:100%"/>
        </FormItem>
        <FormItem label="委托说明" prop="entrustContent" >
          <Input v-model="form.entrustContent" style="width:100%"/>
        </FormItem>
        <FormItem label="版权声明" prop="copyrightStatements" >
          <Input v-model="form.copyrightStatements" style="width:100%"/>
        </FormItem>
        <FormItem label="证明文件Url" prop="certificationFileUrl" >
          <Input v-model="form.certificationFileUrl" style="width:100%"/>
        </FormItem>
        <FormItem label="合作创作协议文件" prop="coCreationAgreement" >
          <Input v-model="form.coCreationAgreement" style="width:100%"/>
        </FormItem>
        <FormItem label="区块链公示Hash" prop="publicHash" >
          <Input v-model="form.publicHash" style="width:100%"/>
        </FormItem>
        <FormItem label="创建者" prop="createBy" >
          <Input v-model="form.createBy" style="width:100%"/>
        </FormItem>
        <FormItem label="创建时间" prop="createDate" >
            <DatePicker type="date" v-model="form.createDate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="更新者" prop="updateBy" >
          <Input v-model="form.updateBy" style="width:100%"/>
        </FormItem>
        <FormItem label="更新时间" prop="updateDate" >
            <DatePicker type="date" v-model="form.updateDate" style="width:100%"></DatePicker>
        </FormItem>
        <FormItem label="备注信息" prop="remarks" >
          <Input v-model="form.remarks" style="width:100%"/>
        </FormItem>
        <FormItem label="删除标记" prop="delFlag" >
          <Input v-model="form.delFlag" style="width:100%"/>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modalVisible=false">取消</Button>
        <Button type="primary" :loading="submitLoading" @click="handleSubmit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "OrderWorksExtend",
  components: {
  },
  data() {
    return {
      loading: true, // 表单加载状态
      modalType: 0, // 添加或编辑标识
      modalVisible: false, // 添加或编辑显示
      modalTitle: "", // 添加或编辑标题
      drop: false,
      dropDownContent: "展开",
      dropDownIcon: "ios-arrow-down",
      searchForm: { // 搜索框初始化对象
        pageNumber: 1, // 当前页数
        pageSize: 10, // 页面大小
        sort: "a.create_date", // 默认排序字段
        order: "desc", // 默认排序方式
        startDate: "", // 起始时间
        endDate: "" // 终止时间
      },
      selectDate: null,
      form: { // 添加或编辑表单对象初始化数据
        orderCommonId: "",
        authorNames: "",
        obligeeNames: "",
        authorSign: "",
        copyrightType: "",
        creativeType: "",
        completeProvince: "",
        completeCity: "",
        completeCountry: "",
        completeDate: "",
        publishProvince: "",
        publishCity: "",
        publishCountry: "",
        publishDate: "",
        publishPlatform: "",
        publishStatus: "",
        powerBy: "",
        powerScope: "",
        workFullname: "",
        workType: "",
        workTypeDesc: "",
        workStatement: "",
        workInstruction: "",
        workCorporate: "",
        workJobProduction: "",
        workCooperationThat: "",
        workEntrustStatementUrl: "",
        entrustContent: "",
        copyrightStatements: "",
        certificationFileUrl: "",
        coCreationAgreement: "",
        publicHash: "",
        createBy: "",
        createDate: "",
        updateBy: "",
        updateDate: "",
        remarks: "",
        delFlag: "",
      },
      // 表单验证规则
      formValidate: {
      },
      submitLoading: false, // 添加或编辑提交状态
      selectList: [], // 多选数据
      selectCount: 0, // 多选计数
      columns: [
        // 表头
        {
          type: "selection",
          width: 60,
          align: "center"
        },
        {
          type: "index",
          width: 60,
          align: "center"
        },
        {
          title: "自增ID",
          key: "orderCommonId",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "作者名字",
          key: "authorNames",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "权利人名称",
          key: "obligeeNames",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "作者署名",
          key: "authorSign",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "权利归属方式. 1.个人作品 2. 合作作品 3.法人作品  4 职务作品  5 委托作品",
          key: "copyrightType",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "创作类型  ORIGINAL(1,  原创 ),ADAPTATION(2,  改编 ),TRANSLATION(3,  翻译 ),COMPILATION(4,  汇编 ),ANNOTATE(5,  注释 ),ARRANGE(6,  整理 ),OTHER(7,  其他 );",
          key: "creativeType",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "完成省份",
          key: "completeProvince",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "完成城市",
          key: "completeCity",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "完成国家",
          key: "completeCountry",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "完成日期",
          key: "completeDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "发布省份",
          key: "publishProvince",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "发布城市",
          key: "publishCity",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "发布国家",
          key: "publishCountry",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "发布日期",
          key: "publishDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "",
          key: "publishPlatform",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "发布状态. 1已发布  0 未发布",
          key: "publishStatus",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "权利取得方式 1 原始取得  2.承受  3 继承 4 其他",
          key: "powerBy",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "权利范围  ：  publish( 发表权 , 1) signature( 署名权 , 2), revision( 修改权 , 3),  completion( 保护作品完整权 , 4),    copy( 复制权 , 5),    launch( 发行权 , 6),  rent( 出租权 , 7),  exhibition( 展览权 , 8),     performance( 表演权 , 9), projection( 放映权 , 10),  broadcast( 广播权 , 11), internet( 信息网络传播权 , 12), produce( 摄制权 , 13), adaptation( 改编权 , 14),   translation( 翻译权 , 15),  compilation( 汇编权 , 16), other( 其他 , 17), all( 全部权利 , 18),   part( 部分权利 , 19);//",
          key: "powerScope",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "作品全称",
          key: "workFullname",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "作品小类，见work_type_copyright中的code字段值",
          key: "workType",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "作品大类，见work_type_copyright中的code字段值",
          key: "workTypeDesc",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "著作权原创声明书url",
          key: "workStatement",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "作品创作说明书",
          key: "workInstruction",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "法人证明文件 copyright_type为2 合作作品时，此字段应有值",
          key: "workCorporate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "职务作品url  copyright_type为4时需要提交此证明",
          key: "workJobProduction",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "合作创作证明",
          key: "workCooperationThat",
          minWidth: 120,
          sortable: false,
        },
        {
          title: " 委托声明url   当copyright_type为5 委托作品时 需要提交的材料",
          key: "workEntrustStatementUrl",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "委托说明",
          key: "entrustContent",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "版权声明",
          key: "copyrightStatements",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "证明文件Url",
          key: "certificationFileUrl",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "合作创作协议文件",
          key: "coCreationAgreement",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "区块链公示Hash",
          key: "publicHash",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "创建者",
          key: "createBy",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "创建时间",
          key: "createDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "更新者",
          key: "updateBy",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "更新时间",
          key: "updateDate",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "备注信息",
          key: "remarks",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "删除标记",
          key: "delFlag",
          minWidth: 120,
          sortable: false,
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    icon: "ios-create-outline"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.edit(params.row);
                    }
                  }
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    icon: "md-trash"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      data: [], // 表单数据
      total: 0 // 表单数据总数
    };
  },
  methods: {
    init() {
      this.getDataList();
    },
    changePage(v) {
      this.searchForm.pageNumber = v;
      this.getDataList();
      this.clearSelectAll();
    },
    changePageSize(v) {
      this.searchForm.pageSize = v;
      this.getDataList();
    },
    handleSearch() {
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.getDataList();
    },
    handleReset() {
      this.$refs.searchForm.resetFields();
      this.searchForm.pageNumber = 1;
      this.searchForm.pageSize = 10;
      this.selectDate = null;
      this.searchForm.startDate = "";
      this.searchForm.endDate = "";
      // 重新加载数据
      this.getDataList();
    },
    changeSort(e) {
      this.searchForm.sort = e.key;
      this.searchForm.order = e.order;
      if (e.order === "normal") {
        this.searchForm.order = "";
      }
      this.getDataList();
    },
    clearSelectAll() {
      this.$refs.table.selectAll(false);
    },
    changeSelect(e) {
      this.selectList = e;
      this.selectCount = e.length;
    },
    selectDateRange(v) {
      if (v) {
        this.searchForm.startDate = v[0];
        this.searchForm.endDate = v[1];
      }
    },
    dropDown() {
      if (this.drop) {
        this.dropDownContent = "展开";
        this.dropDownIcon = "ios-arrow-down";
      } else {
        this.dropDownContent = "收起";
        this.dropDownIcon = "ios-arrow-up";
      }
      this.drop = !this.drop;
    },
    getDataList() {
      this.loading = true;
      // 带多条件搜索参数获取表单数据 请自行修改接口
      // this.getRequest("请求路径", this.searchForm).then(res => {
      //   this.loading = false;
      //   if (res.success) {
      //     this.data = res.result.records;
      //     this.total = res.result.total;
      //   }
      // });
      // 以下为模拟数据
      //this.data = [
      //];
      this.total = this.data.length;
      this.loading = false;
    },
    handleSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true;
          if (this.modalType === 0) {
            // 添加 避免编辑后传入id等数据 记得删除
            delete this.form.id;
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          } else {
            // 编辑
            // this.postRequest("请求地址", this.form).then(res => {
            //   this.submitLoading = false;
            //   if (res.success) {
            //     this.$Message.success("操作成功");
            //     this.getDataList();
            //     this.modalVisible = false;
            //   }
            // });
            // 模拟请求成功
            this.submitLoading = false;
            this.$Message.success("操作成功");
            this.getDataList();
            this.modalVisible = false;
          }
        }
      });
    },
    add() {
      this.modalType = 0;
      this.modalTitle = "添加";
      this.$refs.form.resetFields();
      delete this.form.id;
      this.modalVisible = true;
    },
    edit(v) {
      this.modalType = 1;
      this.modalTitle = "编辑";
      this.$refs.form.resetFields();
      // 转换null为""
      for (let attr in v) {
        if (v[attr] === null) {
          v[attr] = "";
        }
      }
      let str = JSON.stringify(v);
      let data = JSON.parse(str);
      this.form = data;
      this.modalVisible = true;
    },
    remove(v) {
      this.$Modal.confirm({
        title: "确认删除",
        // 记得确认修改此处
        content: "您确认要删除 " + v.name + " ?",
        loading: true,
        onOk: () => {
          // 删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + v.id).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.getDataList();
        }
      });
    },
    delAll() {
      if (this.selectCount <= 0) {
        this.$Message.warning("您还未选择要删除的数据");
        return;
      }
      this.$Modal.confirm({
        title: "确认删除",
        content: "您确认要删除所选的 " + this.selectCount + " 条数据?",
        loading: true,
        onOk: () => {
          let ids = "";
          this.selectList.forEach(function(e) {
            ids += e.id + ",";
          });
          ids = ids.substring(0, ids.length - 1);
          // 批量删除
          // this.deleteRequest("请求地址，如/deleteByIds/" + ids).then(res => {
          //   this.$Modal.remove();
          //   if (res.success) {
          //     this.$Message.success("操作成功");
          //     this.clearSelectAll();
          //     this.getDataList();
          //   }
          // });
          // 模拟请求成功
          this.$Message.success("操作成功");
          this.$Modal.remove();
          this.clearSelectAll();
          this.getDataList();
        }
      });
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.search {
    .operation {
        margin-bottom: 2vh;
    }
    .select-count {
        font-size: 13px;
        font-weight: 600;
        color: #40a9ff;
    }
    .select-clear {
        margin-left: 10px;
    }
    .page {
        margin-top: 2vh;
    }
    .drop-down {
        font-size: 13px;
        margin-left: 5px;
    }
}
</style>